import { PLATFORM_ICONS } from '../../lib/platformIcons'

const META_PATH = PLATFORM_ICONS.find(({ match }) => match === 'facebook')!.path

export default function MetaIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className={className}>
      <path fill="currentColor" d={META_PATH} />
    </svg>
  )
}
